
import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-ab-proposal-view',
	templateUrl: './ab-proposal-view.component.html'
})

export class AbProposalViewComponent implements OnInit {

	@Input('proposal') proposal = [];

	constructor() {
	}

	ngOnInit() {
		console.log("AB", this.proposal);
	}

	printDiv(divName) {
		var printContents = document.getElementById(divName).innerHTML;
		var originalContents = document.body.innerHTML;
		document.body.innerHTML = printContents;
		window.print();
		document.body.innerHTML = originalContents;
   }

}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/proposal-view-modal/ABproposal-view/ab-proposal-view.component.ts